import Icon from '../components/Icon.vue'

Icon.register({
  'credit-card': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M0 432v-176h576v176c0 26.5-21.5 48-48 48h-480c-26.5 0-48-21.5-48-48zM192 364v40c0 6.6 5.4 12 12 12h136c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-136c-6.6 0-12 5.4-12 12zM64 364v40c0 6.6 5.4 12 12 12h72c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-72c-6.6 0-12 5.4-12 12zM576 80v48h-576v-48c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/credit-card.js
// module id = 1244
// module chunks = 0